import messages from './messages'

const transformMostSeen = (guides, isFetching, language) => {
  if (guides.length === 0) {
    return null
  }

  const translated = messages[language]

  return [
    {
      title: translated.related,
      data: [],
      big: true
    },
    {
      title: translated.mostSeen,
      data: guides.map(guide => ({
        name: guide.name,
        pk: guide.pk,
        to: 'tutorials'
      })),
      big: false
    }
  ]
}

const transformAll = (related, isFetching, language) => {
  if (related.length === 0 && isFetching === true) {
    return null
  }

  const troubleData = []
  const tutorialsData = []
  const faqData = []
  const videoData = []

  related.forEach(single => {
    if (single.contentType === 'faq') {
      faqData.push({
        name: single.contentName ? single.contentName : single.contentTitle,
        pk: single.contentKey,
        device: single.device,
        to: 'faqs',
        isSameDevice: single.isSameDevice === false ? false : true
      })
    } else if (single.contentType === 'tutorial') {
      tutorialsData.push({
        name: single.contentName ? single.contentName : single.contentTitle,
        pk: single.contentKey,
        device: single.device,
        to: 'tutorials',
        isSameDevice: single.isSameDevice === false ? false : true
      })
    } else if (single.contentType === 'video') {
      videoData.push({
        name: single.contentName ? single.contentName : single.contentTitle,
        pk: single.contentKey,
        device: single.device,
        to: 'videos',
        isSameDevice: single.isSameDevice === false ? false : true
      })
    } else {
      troubleData.push({
        name: single.contentName ? single.contentName : single.contentTitle,
        pk: single.contentKey,
        device: single.device,
        to: 'guides',
        isSameDevice: single.isSameDevice === false ? false : true
      })
    }
  })

  const noContent =
    tutorialsData.length === 0 &&
    troubleData.length === 0 &&
    faqData.length === 0
  const translated = messages[language]

  return [
    {
      title: noContent ? null : translated.related,
      otherTitle: translated.other,
      data: [],
      big: true
    },
    {
      title: tutorialsData.length !== 0 ? translated.tutorials : null,
      data: tutorialsData,
      big: false
    },
    {
      title: faqData.length !== 0 ? translated.faqs : null,
      data: faqData,
      big: false
    },
    {
      title: troubleData.length !== 0 ? translated.guides : null,
      data: troubleData,
      big: false
    },
    {
      title: videoData.length !== 0 ? translated.videos : null,
      data: videoData,
      big: false
    },
    {
      title: noContent ? translated.noContent : null,
      data: [],
      big: true
    }
  ]
}

const transformSuggested = (related, isFetching, language) => {
  if (related.length === 0 && isFetching === true) {
    return null
  }

  const tutorialsData = []

  related.forEach(single => {
    if (single.object_type === 'tutorial') {
      tutorialsData.push({ name: single.name, pk: single.pk, to: 'tutorials' })
    }
  })

  return [
    {
      title: tutorialsData.length !== 0 ? messages[language].suggested : null,
      data: tutorialsData,
      big: true
    }
  ]
}

export const RELATED_HELPERS = {
  mostSeen: transformMostSeen,
  all: transformAll,
  suggested: transformSuggested,
  related: transformAll,
  swimlane: transformAll
}



// WEBPACK FOOTER //
// ./src/containers/RelatedSidebar/helpers.js